import { render, staticRenderFns } from "./TarifaCompra.vue?vue&type=template&id=65a04a47"
import script from "./TarifaCompra.vue?vue&type=script&lang=js"
export * from "./TarifaCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports